import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import LoginMenuItem from 'components/LoginMenuItem';

import W from '../_core/Wrapper';
import Header from '../_core/Header';
import Hero from './Hero';
import Container from '../_core/Container';
import Footer from '../_core/Footer';

import CourseModal from './CourseModal';
import CourseSearch from './CourseSearch';

import MyLearning from './MyLearning';
import MyLearningView from './MyLearningView';
import MyLearningViewSwitcher from './MyLearningViewSwitcher';
import UnderlineLink from 'components/_core/UnderlineLink';
import Seo from 'components/Seo';
import { getEnvVar } from 'utils/get-env-var';
import SaleBanner from 'components/Home/SaleBanner';

const navItems = [
    () => <li><UnderlineLink to={`${getEnvVar('ROOT_ROUTE')}/account`}>Account</UnderlineLink></li>,
    () => <li><LoginMenuItem /></li>
];

const Wrapper = styled(W)`
    margin-bottom: 60px;

    ${props => props.$hasActiveSaleBanner && `margin-top: 160px;`}
`;

const SubscriberLanding = () => {
    const isSubscriber = useSelector(state => state.user.userData.isSubscriber);
    const activeSale = useSelector(state => state.sales.sale);
    const hasActiveSaleBanner = activeSale && activeSale.banner_text;

    return (
        <>
            <Seo
                title="Drum Courses"
                description="Browse the full library of JP Bouvet Method drum courses — step-by-step online lessons in improvisation, groove, technique and creativity for every level of drummer." />
            <SaleBanner />
            <Wrapper $hasActiveSaleBanner={hasActiveSaleBanner}>
                <Header hasActiveSaleBanner={hasActiveSaleBanner} hideLogoUntilScroll={!isSubscriber} dontFadeBarIn={isSubscriber} navItems={navItems} />
                {isSubscriber ? <MyLearning /> : <Hero />}
                <Container style={{ padding: '30px 0' }}>
                    <MyLearningViewSwitcher />
                    <MyLearningView />
                </Container>
            </Wrapper>
            <Footer />
            <CourseModal />
            <CourseSearch />
        </>
    );
};

export default SubscriberLanding;
